<template>
  <span
    :class="[
      'badge',
      'text-white',
      statuses[purchase.status].class,
    ]"
    style="line-height: 1.2"
    >{{ statuses[purchase.status].text }}</span
  >
</template>

<script>
export default {
  props: {
    purchase: {},
  },

  data: () => ({
    statuses: {
      
        d: {
          text: "Rascunho",
          class: "badge-primary",
          value: "0",
        },

        p: {
          text: "Compra",
          class: "badge-success",
        },

        c: {
          text: "Cancelada",
          class: "badge-danger",
        },
      
    },
  }),
};
</script>

<style>
</style>